import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { styles } from '../../constants';

import { connect } from 'react-redux';

import { Button, Text, Form, Item, Label, Input, H3, Content, CardItem, Card } from "native-base";

import {
    sendGetEmailConfirm,
    setCurrentAction
} from '../../actions/';

class GetEmailConfirm extends Component {
    state = {
        email: this.props.email
    };

    onChangeInput = (key, e) => this.setState({ [key]: e.target.value });

    handlerSubmit = () => {
        const { dispatch } = this.props;
        dispatch(sendGetEmailConfirm(this.state));
    };

    handlerClickLogin = (event) => {
        const { dispatch } = this.props;
        event.preventDefault();
        dispatch(setCurrentAction('login'));
    };

    render() {
        const { authCause, currentAction } = this.props;
        const { email } = this.state;

        return <Content style={styles.content}>
            <Form>
                <H3 style={styles.appDescription}>Запрос кода подтверждения</H3>
                {currentAction === 'getConfirmSuccess' ? <Text>Код подтверждения отправлен на вашу почту. Вам необходимо перейти по ссылке в письме.</Text> :
                    <>
                        <Item stackedLabel>
                            <Label>Email*</Label>
                            <Input
                                keyboardType="email-address"
                                onChange={(e) => this.onChangeInput('email', e)}
                                value={email}
                            />
                        </Item>
                        <Button
                            large
                            full
                            rounded
                            onPress={this.handlerSubmit}
                            style={styles.button}
                        >
                            <Text>Отправить</Text>
                        </Button>
                    </>}
                <Button transparent block style={styles.bottomLink} onPress={this.handlerClickLogin}>
                    <Text>Вход</Text>
                </Button>
                {authCause ? <Card>
                    <CardItem>
                        <Text>{authCause}</Text>
                    </CardItem>
                </Card> : null}
            </Form>
        </Content>;
    }
}

GetEmailConfirm.propTypes = {
    dispatch: PropTypes.func.isRequired,
    authCause: PropTypes.string,
    currentAction: PropTypes.string,
    email: PropTypes.string,
    code: PropTypes.string
};

GetEmailConfirm.defaultProps = {
    authCause: ''
};

const mapStateToProps = (state) => ({
    authCause: state.authCause
});

export default connect(mapStateToProps)(GetEmailConfirm);
